module.exports = __webpack_public_path__ + "0af5d249/img/google.68f3823e.svg";